import { render } from "./WebSocket.vue?vue&type=template&id=47448e40&scoped=true"
import script from "./WebSocket.vue?vue&type=script&lang=js"
export * from "./WebSocket.vue?vue&type=script&lang=js"

import "./WebSocket.vue?vue&type=style&index=0&id=47448e40&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47448e40"]])

export default __exports__